import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import API_BASE_URL from 'config/api';

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

// Image
import logoImage from "assets/images/illustrations/logicookie-white.png";

function Illustration() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const isValid = /\S+@\S+\.\S+/.test(email);

  const handleRequestReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const response = await axios.post(
        `${API_BASE_URL}/auth/request-password-reset`,
        { email: email.trim() },
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200 || response.status === 201) {
        setSuccess(
          "Eğer bu e‑posta ile kayıtlı bir hesap varsa, şifre sıfırlama bağlantısı gönderildi. Lütfen e‑postanızı kontrol edin."
        );
      } else {
        setError(response.data?.message || "İstek işlenemedi. Lütfen tekrar deneyin.");
      }
    } catch (err) {
      if (err?.response?.status === 429) {
        setError("Çok fazla istek. Lütfen kısa bir süre sonra tekrar deneyin.");
      } else {
        setError(err?.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <IllustrationLayout
      title="Şifre Sıfırlama"
      description="E‑posta adresinizi yazın; size şifre sıfırlama bağlantısı gönderelim."
      illustration={logoImage}
    >
      <MDBox component="form" role="form" onSubmit={handleRequestReset}>
        {error && (
          <MDBox mb={2}>
            <MDTypography variant="body2" color="error">
              {error}
            </MDTypography>
          </MDBox>
        )}
        {success && (
          <MDBox mb={2}>
            <MDTypography variant="body2" color="success.main">
              {success}
            </MDTypography>
          </MDBox>
        )}
        <MDBox mb={2}>
          <MDInput
            type="email"
            label="E-posta"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            required
            autoComplete="email"
            sx={{
              "& .MuiInputLabel-root": {
                lineHeight: "1.2",
                top: "-2px",
              },
            }}
          />
        </MDBox>
        <MDBox mt={4} mb={1}>
          <MDButton
            variant="gradient"
            color="blue"
            size="large"
            fullWidth
            type="submit"
            disabled={loading || !isValid}
          >
            {loading ? "Gönderiliyor..." : "Sıfırlama Bağlantısı Gönder"}
          </MDButton>
        </MDBox>
        <MDBox mt={3} textAlign="center">
          <MDTypography variant="button" color="text">
            Giriş sayfasına dönmek ister misiniz?{" "}
            <MDTypography
              component={Link}
              to="/sign-in"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Giriş Yap
            </MDTypography>
          </MDTypography>
        </MDBox>
      </MDBox>
    </IllustrationLayout>
  );
}

export default Illustration;
